<template>
  <v-container
    v-if="props.locationId && location"
    class="mt-2">
    <v-row class="fix-row">
      <v-col
        cols="8"
        class="bordered bg-white">
        <CalcInputNumber
          :id="props.locationId"
          class="mb-4"
          field="material_overhead_surcharge_percentage_location"
          max="100"
          min="0"
          :rules="[percents, positive]"
          step="0.01" />

        <CalcInputNumber
          :id="props.locationId"
          class="mb-4"
          field="residual_manufacturing_overhead_surcharge_percentage_location"
          max="100"
          min="0"
          :rules="[percents, positive]"
          step="0.01" />

        <CalcInputNumber
          :id="props.locationId"
          class="mb-4"
          field="administrative_and_sales_overhead_surcharge_percentage_location"
          max="100"
          min="0"
          :rules="[percents, positive]"
          step="0.01" />

        <CalcInputNumber
          :id="props.locationId"
          class="mb-4"
          field="research_and_development_overhead_surcharge_percentage_location"
          max="100"
          min="0"
          :rules="[percents, positive]"
          step="0.01" />

        <CalcInputNumber
          :id="props.locationId"
          class="mb-4"
          density="compact"
          field="calculated_venture_costs_surcharge_percentage_location"
          hide-details="auto"
          max="100"
          min="0"
          :rules="[percents, positive]"
          step="0.01" />
      </v-col>
      <v-col
        id="surcharges_notes_col"
        cols="4"
        class="bordered bg-white">
        <NotesEditor
          :id="locationId"
          field="surcharges_notes_location"
          :placeholder="
            $t('entities.location.fields.surcharges_notes_location')
          " />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { useTranslation } from "i18next-vue";

import { useCommonRules } from "@/validations/common";
import { ref, onMounted } from "vue";
import { useSpaceStore } from "@/stores/spaceStore";
import NotesEditor from "@/components/Elements/NotesEditor.vue";
import CalcInputNumber from "@/components/Elements/CalcInputNumber.vue";

const { t } = useTranslation();
const location = ref(null);
const { percents, positive } = useCommonRules(t);

const spaceStore = useSpaceStore();

const props = defineProps({
  locationId: {
    type: String,
    required: true
  }
});

onMounted(() => {
  location.value = spaceStore.getElement(props.locationId);
});
</script>

<style scoped>
#surcharges_notes_col {
  height: 310px !important;
  margin-left: 12px;
  padding: 16px;
  /* margin-top: 12px; */
  margin-right: -12px;
  padding-bottom: 84px;
}

.fix-margin {
  margin: 0 -16px;
  padding: 16px;
}

.fix-row {
  margin-right: -4px;
}
</style>
